import { type EdgeId, isPathLookupEdgeData } from '@ipfabric/utils';
import type { PacketDetail } from 'components/DeviceView/deviceViewTypes';
import type { GraphData } from 'components/Graph/model/GraphData';
import { hasPacketSiblingPathLookupNode } from './hasPacketSiblingPathLookupNode';

export const getPacketEdgeDetail = (
  graphData: GraphData,
  edgeId: EdgeId,
): PacketDetail | null => {
  const edgeData = graphData.edges[edgeId];
  if (edgeData !== undefined && isPathLookupEdgeData(edgeData)) {
    return {
      edgeDirection: edgeData.direction,
      hasNextPathLookupNode: hasPacketSiblingPathLookupNode(
        graphData,
        'target',
        edgeId,
      ),
      hasPreviousPathLookupNode: hasPacketSiblingPathLookupNode(
        graphData,
        'source',
        edgeId,
      ),
      id: edgeId,
      labels: edgeData.labels,
      showAnimation: true,
      sourceLabel: graphData.nodes[edgeData.source]?.label ?? null,
      targetLabel: graphData.nodes[edgeData.target]?.label ?? null,
      packet: edgeData.packet,
    };
  }
  return null;
};
